export default __webpack_public_path__ + "static/media/Ed.bce3b90b.png";